<style lang="less">
.payment-method {
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.payment-method.selected {
  border-color: #1677ff;
  background: #f0f7ff;
}
.method-icon {
  display: flex;
  align-items: center;
}
.method-icon img {
  width: 24px;
  height: 24px;
}
</style>
<template>
  <div>
    <div
      class="payment-method"
      :class="payType == 'wechat' ? 'selected': ''"
      @click="tapPayType('wechat')"
    >
      <div class="method-icon">
        <basic-icon
          name="gongzhonghao"
          color="#10da6e"
          :size="28"
          class="mr-2"
        />
        微信快捷支付
      </div>
      <span
        v-if="payType=='wechat'"
        class="text-[#1677ff]"
      >✓</span>
    </div>

    <div
      class="payment-method"
      :class="payType == 'balance' ? 'selected': ''"
      @click="tapPayType('balance')"
    >
      <div class="method-icon">
        <basic-icon
          name="exchange-cny-line"
          color="#fdb44d"
          :size="28"
          class="mr-2"
        />
        储值支付（余额：<span class="text-[#1677ff] font-semibold">￥{{ userStore.user?.wallet?.totalBalance || 0 }}</span>）
      </div>
      <span
        v-if="payType=='balance'"
        class="text-[#1677ff]"
      >✓</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { newPaymentMethodProps } from './props'

const emits = defineEmits(['update:modelValue'])
const props = defineProps(newPaymentMethodProps)
const userStore = useUserStore()
const payType = ref<'wechat' | 'balance'>(props.modelValue)

const tapPayType = v => {
  payType.value = v
  emits('update:modelValue', payType.value)
}
</script>